import * as React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button
} from "@material-ui/core";

export interface ConfirmationOptions {
    catchOnCancel?: boolean;
    variant?: "danger" | "info";
    title?: string;
    description?: string;
    cancelText?: string;
    confirmationText?: string;
}

interface ConfirmationDialogProps extends ConfirmationOptions {
    open: boolean;
    onSubmit: () => void;
    onClose: () => void;
}

export const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
    open,
    title,
    variant,
    cancelText,
    confirmationText,
    description,
    onSubmit,
    onClose
}) => {
    return (
        <Dialog open={open}>
            <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
            <DialogContent>
                <DialogContentText>{description}</DialogContentText>
            </DialogContent>
            <DialogActions>
                {variant === "danger" && (
                    <>
                        <Button color="primary" onClick={onSubmit}>
                            {confirmationText ? confirmationText : "OK"}
                        </Button>
                        <Button color="primary" onClick={onClose} autoFocus>
                            {cancelText ? cancelText : "Cancel"}
                        </Button>
                    </>
                )}

                {variant === "info" && (
                    <Button color="primary" onClick={onSubmit}>
                        {confirmationText ? confirmationText : "OK"}
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
};
